import { createAction, props } from "@ngrx/store";
import { ILayerDataResponse } from "../../interfaces/layer/ILayerDataResponse";
import { ILayerDataSearch } from "../../interfaces/layer/ILayerDataSearch";
import { ILayer } from "../../interfaces/layer/ILayer";

export const loadLayers = createAction("[Layer] Load Layers");
export const loadLayersSuccess = createAction(
  "[Layer] Load Layers Success",
  props<{ layers: Array<ILayer>, code?: string }>()
);

export const loadLayersFailure = createAction(
  "[Layer] Load Layers Failure",
  props<{ error: string }>()
);
export const loadLayerSuceessChecked = createAction(
    "[Layer] Load Layers Success Checked",
    props<{ layers: Array<ILayer>}>()
  );
export const loadLayerData = createAction(
    "[Layer] Load Layer Data",
    props<ILayerDataSearch>()
  );
  
  export const loadLayerDataSuccess = createAction(
    "[Layer] Load Layer Data Success",
    props<{ layerData: ILayerDataResponse }>() 
  );
  
  export const loadLayerDataFailure = createAction(
    "[Layer] Load Layer Data Failure",
    props<{ error: string }>()
  );
  export const searchCity = createAction(
    "[Layer] Search City",
    props<{ searchTerm: string }>()
  );
  
  export const searchCitySuccess = createAction(
    "[Layer] Search City Success",
    props<{ cities: Array<{ name: string; bbox: number[] }> }>()
  );
  
  export const searchCityFailure = createAction(
    "[Layer] Search City Failure",
    props<{ error: string }>()
  );
  export const setSelectedCity = createAction(
    '[Layer] Set Selected City',
    props<{ city: { name: string; bbox: number[] } }>()
  );